import { getDefaultHeaders, setCsrfToken } from "./utils";

export async function translationUpload(comicFile, excelFile = null, metadata = {}) {
  let formData = new FormData();
  
  // Append files to form
  formData.append('comic_file', comicFile);
  if (excelFile) {
    formData.append('excel_file', excelFile);
  }
  
  // Append metadata fields if provided
  if (metadata.title) {
    formData.append('title', metadata.title);
  }
  if (metadata.series) {
    formData.append('series', metadata.series);
  }
  if (metadata.volume) {
    formData.append('volume', metadata.volume);
  }
  
  let headers = await getDefaultHeaders(false, true);
  
  const requestOptions = {
    method: "POST",
    headers: headers,
    body: formData,
  };

  const url = "/api/process-translation-files/";
  
  try {
    const response = await fetch(url, requestOptions);
    const jsonResponse = await response.json();
    
    // Handle CSRF failure
    if (response.status === 403 && jsonResponse.detail && jsonResponse.detail.includes("CSRF Failed")) {
      await setCsrfToken();
      return await translationUpload(comicFile, excelFile, metadata);
    }
    
    return {
      success: response.ok,
      data: jsonResponse,
      status: response.status
    };
  } catch (err) {
    console.error("Error uploading translation files:", err);
    return {
      success: false,
      error: err.message,
      status: 500
    };
  }
}
